var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as moment from 'moment';
import { BaseEntity, MemoizeGetters, Transform, toDate } from './base';
let NoteModel = NoteModel_1 = class NoteModel extends BaseEntity {
    get relativeTime() {
        let momentDate = moment(this.createdAt);
        return momentDate.fromNow();
    }
    get url() {
        const matches = this.message.match(NoteModel_1.UrlRegex);
        return matches ? matches[0] : null;
    }
    get formattedMessage() {
        if (this.url) {
            const newUrl = `<span class='url'>${this.url}</span>`;
            return this.message.replace(this.url, newUrl);
        }
        return this.message;
    }
};
NoteModel.UrlRegex = /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/;
__decorate([
    Transform(toDate),
    __metadata("design:type", Date)
], NoteModel.prototype, "createdAt", void 0);
NoteModel = NoteModel_1 = __decorate([
    MemoizeGetters
], NoteModel);
export { NoteModel };
var NoteModel_1;
//# sourceMappingURL=note.js.map


// WEBPACK FOOTER //
// ./src/models/note.ts.pre-build-optimizer.js